import AnalyticsProvider from './analytics-provider.component';
import Service from './analytics-provider.service';
import * as Constants from './analytics-provider.constants';
import * as Epics from './analytics-provider.epic';

export { AnalyticsProvider, Service, Constants, Epics };

export default AnalyticsProvider;
